module.exports = __webpack_public_path__ + "img/top3.5cc11968.png";